<template>
	<vxe-table :header-cell-class-name="purchaseorderDetailHeader" border :row-config="{isHover: true}"
		:data="tableData" height="100%">
		<vxe-column type="seq" width="60"></vxe-column>
		<vxe-column field="goodsName" title="名称" show-overflow="ellipsis"></vxe-column>
		<vxe-column field="skuCode" title="编码"></vxe-column>
		<vxe-column field="skuName" title="规格"></vxe-column>
		<vxe-column field="unitName" title="单位"></vxe-column>
		<vxe-column field="size" title="数量"></vxe-column>
		<vxe-column field="price" title="单价"></vxe-column>
		<vxe-column field="status" title="状态" align="center">
			<template #default="{ row }">
				<el-tag effect="dark" size="mini" :type="statusMap[row.status].type" v-if="statusMap[row.status]">
					{{ statusMap[row.status].status }}</el-tag>
			</template>
		</vxe-column>
	</vxe-table>
</template>
<style scoped>

</style>
<style>
	.purchaseorderDetailHeader {
		background-color: #DCDFE6;
	}
</style>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return '供应商'
				}
			},
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading: false,
				tableData: [],
				statusMap: {
					0: {
						status: '未到货',
						type: 'danger'
					},
					1: {
						status: '部分到货',
						type: 'primary'
					},
					2: {
						status: '完成',
						type: 'success'
					},
					3: {
						status: '关闭',
						type: 'info'
					}
				}

			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			getPurchaseDetail(billID) {
				this.$api.wechaty.getPurchaseDetail(billID).then((res) => {
					this.tableData = res
				})
			},
			purchaseorderDetailHeader() {
				return 'purchaseorderDetailHeader'
			},
		},
		components: {

		}
	}
</script>
